module.exports = __webpack_public_path__ + "media/img/event/banner-edm-8d74acbb9457483f248c14c57746a4f9.jpg";